import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ChargerSupplyConnectionForm: FC = () => {
    const classes = useStyles();
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.CHARGER_SUPPLY_CONNECTION
    >();

    const convertValue = (): string => {
        if (values.chargerSupplyConnection.value.new) return "new";
        if (values.chargerSupplyConnection.value.existing) return "existing";
        return "";
    };

    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Anschluss der Ladeeinrichtung
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.chargerSupplyConnection.value = {
                                    new: v.indexOf("new") >= 0,
                                    existing: v.indexOf("existing") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <FormControlLabel
                            key={"test"}
                            value="existing"
                            control={<Radio />}
                            label="Bereits beantragter Neuanschluss oder bestehender Netzanschluss"
                            text="Die Ladeeinrichtung soll über den zuvor beantragten Neuanschluss oder einen bereits bestehenden Netzanschluss angeschlossen werden."
                            error={values.chargerSupplyConnection.error !== null}
                        />
                        <FormControlLabel
                            key={"test2"}
                            value="new"
                            control={<Radio />}
                            label="Separater Netzanschluss"
                            text="Die Ladeeinrichtung soll über einen separaten Netzanschluss angeschlossen werden."
                            error={values.chargerSupplyConnection.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
